import { TRANSACTION_STATUS } from './constants'
import { Fragment } from 'react'
import Swal from 'sweetalert2'
import { postWithdrawPayment } from '../../services/payment'

export const getDateDDMMYYYY = (value) => {
  const date = new Date(value)
  const day = date.getDate().toString()
  const month = (date.getMonth() + 1).toString()
  const year = date.getFullYear()
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`
}


export const getAmountCells = (transaction) => {
  const amount = Number(transaction.amount).toLocaleString()

  const isWithdrawOrSpend = [TRANSACTION_STATUS.WITHDRAW, TRANSACTION_STATUS.SPEND].includes(transaction.type)
  const firstCell = isWithdrawOrSpend ? amount : ''
  const secondCell = isWithdrawOrSpend ? '' : amount

  return (
    <Fragment>
      <td>{firstCell}</td>
      <td>{secondCell}</td>
    </Fragment>
  )
}

const setupWithdrawInputs = () => {
  const onInput = (event) => {
    const { value } = event.target

    if (!value) {
      event.target.value = ''
      return
    }

    event.target.value = value.replace(/[^0-9.]/g, '').replace(/(\.\d\d)\d+/g, '$1')
  }

  const inputs = document.querySelectorAll('#swal-input1, #swal-input2')

  inputs.forEach((input) => {
    if (!input) return
    input.addEventListener('input', onInput)
    input.setAttribute('placeholder', 'จำนวน')
    input.setAttribute('style', 'margin-top: 8px;')
  })
}

export const showWithdrawPopup = (userId, points) => {
  return Swal.fire({
    title: 'กรุณากรอกจำนวนที่ต้องการถอน',
    showCancelButton: true,
    confirmButtonText: 'ยืนยัน',
    cancelButtonText: 'ยกเลิก',
    didOpen: setupWithdrawInputs,
    html: `
      <div>
        <span>แคชที่ลูกค้ามี:</span>
        <span style="font-weight:700;">${points}</span>
        <input id="swal-input1" class="swal2-input" />
        <input id="swal-input2" class="swal2-input" />
      </div>
    `,
    allowEnterKey: false,
    focusConfirm: false,
    showLoaderOnConfirm: true,
    preConfirm: async () => {
      const [firstInput, secondInput] = document.querySelectorAll('#swal-input1, #swal-input2')

      if (!Number(firstInput.value) || !Number(secondInput.value)) {
        Swal.showValidationMessage('กรุณากรอกข้อมูลให้ถูกต้อง')
        return false
      }

      if (firstInput.value !== secondInput.value) {
        Swal.showValidationMessage('จำนวนที่ต้องการถอนไม่ตรงกัน')
        return false
      }

      try {
        await postWithdrawPayment(userId, firstInput.value)

        Swal.fire({
          icon: 'success',
          title: 'สำเร็จ',
          text: 'ทำรายการเสร็จสิ้น',
        })
      } catch (error) {
        Swal.showValidationMessage(error.message)
        return false
      }
    },
  })
}

